import { render, staticRenderFns } from "./AddFormRecommendation.vue?vue&type=template&id=1a6e0520"
import script from "./AddFormRecommendation.vue?vue&type=script&lang=js"
export * from "./AddFormRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports